import { Pipe, PipeTransform } from '@angular/core';
import { NodeData, NodeType } from '../interfaces/node.interface';
import { TriggerNodesEnum } from '../services/graph.utils';

@Pipe({
  name: 'hideNodeAction',
  standalone: true,
})
export class HideNodeActionPipe implements PipeTransform {
  public transform(nodeData: NodeData, excludeTypes: NodeType[]): boolean {
    if (excludeTypes.includes(nodeData.type) && nodeData.name !== TriggerNodesEnum.Schedule) {
      return true;
    }

    return false;
  }
}
